// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"496":"5f8c38ac19c9932b","760":"aa6104d5bf62399e","791":"7523fa0f07900b73"}[chunkId] + ".js";
};